import { SystemStyleObject } from '@chakra-ui/react';

import { thinScrollbar } from '$styles/tokens';

export const tagStyles: SystemStyleObject = {
  '& > *:first-of-type': { mt: 0 },

  p: {
    color: 'text.primary',
    fontSize: '17px',
    lineHeight: 1.7,
    mt: '20px',
  },

  strong: {
    color: 'text.primary',
    fontWeight: 600,
  },

  em: {
    fontFamily: 'display',
    fontStyle: 'italic',
    color: 'text.primary',
  },

  'h1, h2, h3, h4, h5, h6': {
    fontFamily: 'display',
    fontWeight: 400,
    letterSpacing: '-0.02em',
    color: 'text.primary',
    mt: '56px',
    mb: '12px',
    lineHeight: 1.1,
  },

  h1: { fontSize: '48px' },
  h2: { fontSize: '36px' },
  h3: { fontSize: '28px' },
  h4: { fontSize: '22px' },

  'ol, ul': {
    pl: '24px',
    mt: '16px',
    color: 'text.primary',
  },

  li: {
    mt: '8px',
    fontSize: '17px',
    lineHeight: 1.6,
  },

  blockquote: {
    borderLeftWidth: '2px',
    borderColor: 'accent.500',
    pl: '20px',
    py: '4px',
    my: '24px',
    color: 'text.muted',
    fontStyle: 'italic',
  },

  a: {
    color: 'text.primary',
    borderBottom: '1px solid',
    borderColor: 'line.subtle',
    transition: 'color 0.2s ease, border-color 0.2s ease',
    _hover: {
      color: 'accent.500',
      borderColor: 'accent.500',
    },
  },

  pre: {
    maxWidth: 'full',
    width: 'full',
    my: '20px',
    borderRadius: '2px',
    borderWidth: '1px',
    borderColor: 'line.subtle',
    overflow: 'hidden',

    '.codeStyle': {
      ...thinScrollbar,
      fontSize: '14px !important',
      margin: '0 !important',
    },
  },

  'code:not(pre code)': {
    fontFamily: 'mono',
    fontSize: '14px',
    bg: 'bg.elevated',
    border: '1px solid',
    borderColor: 'line.subtle',
    borderRadius: '2px',
    px: '6px',
    py: '2px',
    color: 'accent.500',
  },

  hr: {
    borderColor: 'line.subtle',
    my: '40px',
  },

  img: {
    borderRadius: '2px',
    my: '20px',
  },
};
